import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/policy-pages.css';

const PolicyPageLayout = ({ title, subtitle, variant = 'terms', icon: Icon, children }) => {
  return (
    <article className={`policy-page policy-page--${variant}`}>
      <div className="policy-page-bg" aria-hidden="true" />

      <div className="policy-page-inner">
        <header className="policy-page-header">
          <div className="policy-page-accent" aria-hidden="true" />
          <div className="policy-page-header-body">
            {Icon && (
              <span className="policy-page-icon">
                <Icon size={26} strokeWidth={2} aria-hidden="true" />
              </span>
            )}
            <div>
              <p className="policy-page-label">Legal &amp; regulatory</p>
              <h1>{title}</h1>
              {subtitle && <p className="policy-page-subtitle">{subtitle}</p>}
            </div>
          </div>
          <span className="policy-page-brand">MR Rupya</span>
        </header>

        <div className="policy-page-body">
          {children}
        </div>

        <div className="policy-page-foot">
          <p>
            Have questions about this document?{' '}
            <Link to="/contact-us">Contact us</Link>
            {' · '}
            <Link to="/faqs">View FAQs</Link>
          </p>
        </div>
      </div>
    </article>
  );
};

export default PolicyPageLayout;
